var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentegatepass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.44444C2 5.98985 3.98985 4 6.44444 4H17.5556C20.0102 4 22 5.98985 22 8.44444C22 8.98773 21.6884 9.48288 21.1986 9.71798L20.7113 9.95192C18.993 10.7767 18.993 13.2233 20.7113 14.0481L21.1986 14.282C21.6884 14.5171 22 15.0123 22 15.5556C22 18.0102 20.0102 20 17.5556 20H6.44444C3.98985 20 2 18.0102 2 15.5556C2 15.0123 2.31157 14.5171 2.80135 14.282L3.28872 14.0481C5.00702 13.2233 5.00702 10.7767 3.28872 9.95192L2.80135 9.71798C2.31157 9.48288 2 8.98773 2 8.44444Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0175 9.73737C11.3268 8.75421 12.6732 8.75421 12.9825 9.73737C13.1208 10.177 13.5174 10.4747 13.965 10.4747C14.9657 10.4747 15.3818 11.7976 14.5722 12.4052C14.2101 12.6769 14.0586 13.1586 14.1969 13.5983C14.5062 14.5814 13.4168 15.399 12.6072 14.7914C12.2451 14.5196 11.7549 14.5196 11.3928 14.7914C10.5832 15.399 9.49385 14.5814 9.80309 13.5983C9.94139 13.1586 9.78989 12.6769 9.42782 12.4052C8.6182 11.7976 9.03429 10.4747 10.035 10.4747C10.4826 10.4747 10.8792 10.177 11.0175 9.73737Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentegatepass);
export default __webpack_public_path__ + "static/media/recentegatepass.bb3277d6763fa6f773cebdefb6c9f46e.svg";
export { ForwardRef as ReactComponent };